/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Settings_Stripe_ConnectedInputs */

const en_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connected ✓`)
};

const es_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe conectado ✓`)
};

const fr_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connecté ✓`)
};

const de_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe verbunden ✓`)
};

const ja_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe接続済み ✓`)
};

const zh_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 已连接 ✓`)
};

const ar_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم ربط Stripe ✓`)
};

const id_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Terhubung ✓`)
};

const it_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connesso ✓`)
};

const ru_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe подключен ✓`)
};

const pt_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Conectado ✓`)
};

const ko_seller_settings_stripe_connected = /** @type {(inputs: Seller_Settings_Stripe_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 연결됨 ✓`)
};

/**
* | output |
* | --- |
* | "Stripe Connected ✓" |
*
* @param {Seller_Settings_Stripe_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_settings_stripe_connected = /** @type {((inputs?: Seller_Settings_Stripe_ConnectedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Settings_Stripe_ConnectedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_settings_stripe_connected(inputs)
	if (locale === "es") return es_seller_settings_stripe_connected(inputs)
	if (locale === "fr") return fr_seller_settings_stripe_connected(inputs)
	if (locale === "de") return de_seller_settings_stripe_connected(inputs)
	if (locale === "ja") return ja_seller_settings_stripe_connected(inputs)
	if (locale === "zh") return zh_seller_settings_stripe_connected(inputs)
	if (locale === "ar") return ar_seller_settings_stripe_connected(inputs)
	if (locale === "id") return id_seller_settings_stripe_connected(inputs)
	if (locale === "it") return it_seller_settings_stripe_connected(inputs)
	if (locale === "ru") return ru_seller_settings_stripe_connected(inputs)
	if (locale === "pt") return pt_seller_settings_stripe_connected(inputs)
	return ko_seller_settings_stripe_connected(inputs)
});